// extracted by css-extract-rspack-plugin
export default {"root":"src-features-Integrations-components-IntegrationStatusBadge-module__root-zSogzS","loadingContent":"src-features-Integrations-components-IntegrationStatusBadge-module__loadingContent-L9SCKy"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-features-Integrations-components-IntegrationStatusBadge-module__root-zSogzS\",\"loadingContent\":\"src-features-Integrations-components-IntegrationStatusBadge-module__loadingContent-L9SCKy\"}";
        // 1790730173219
        var cssReload = require("../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  